<template>
  <div class="home">
    <van-divider>2022-09-13</van-divider>
    <van-empty
      @click="out15"
      image="https://jsjdj.hdu.edu.cn/images/16.jpg"
      :image-size="[300,200]"
      description="计算机学院（软件学院）党委理论学习中心组召开“习近平谈治国理政”（第四卷）、“三..."
    />
    <van-divider>2022-07-07</van-divider>
    <van-empty
      @click="out14"
      image="https://jsjdj.hdu.edu.cn/images/15.jpg"
      :image-size="[300,200]"
      description="计算机学院（软件学院）党委理论学习中心组举行“习近平浙江足迹”“浙江省第十五次党..."
    />
    <van-divider>2022-07-01</van-divider>
    <van-empty
      @click="out13"
      image="https://jsjdj.hdu.edu.cn/images/14.jpg"
      :image-size="[300,200]"
      description="计算机学院党委召开纪念建党101周年暨“七一”表彰大会"
    />
    <van-divider>2022-06-24</van-divider>
    <van-empty
      @click="out12"
      image="https://jsjdj.hdu.edu.cn/images/13.jpg"
      :image-size="[300,200]"
      description="校党委第五巡察组巡察向计算机学院党委反馈巡察意见"
    />
    <van-divider>2022-06-13</van-divider>
    <van-empty
      @click="out11"
      image="https://jsjdj.hdu.edu.cn/images/12.jpg"
      :image-size="[300,200]"
      description="机关综合党支部开展警示教育活动"
    />
    <van-divider>2022-04-27</van-divider>
    <van-empty
      @click="out10"
      image="https://jsjdj.hdu.edu.cn/images/11.jpg"
      :image-size="[300,200]"
      description="校党委巡察计算机学院党委工作动员会召开"
    />
    <van-divider>2021-11-19</van-divider>
    <van-empty
      @click="out3"
      image="https://jsjdj.hdu.edu.cn/images/4.jpg"
      :image-size="[300,200]"
      description="大创小镇企业党组织与高校院系党组织党建共建大会"
    />
    <van-divider>2021-11-19</van-divider>
    <van-empty
      @click="out4"
      image="https://jsjdj.hdu.edu.cn/images/5.jpg"
      :image-size="[300,200]"
      description="【清廉自守 风清气正】计算机学院举办清廉文化台牌设计大赛"
    />
    <van-divider>2021-11-19</van-divider>
    <van-empty
      @click="out5"
      image="https://jsjdj.hdu.edu.cn/images/6.jpg"
      :image-size="[300,200]"
      description="计算机学院研究生学术道德与学术建设宣誓仪式"
    />
    <van-divider>2021-11-19</van-divider>
    <van-empty
      @click="out6"
      image="https://jsjdj.hdu.edu.cn/images/7.jpg"
      :image-size="[300,200]"
      description="【党史学习教育“三为”专题实践】 计算机学院走访杭州中科先进技术研究院"
    />
    <van-divider>2021-11-19</van-divider>
    <van-empty
      @click="out7"
      image="https://jsjdj.hdu.edu.cn/images/8.jpg"
      :image-size="[300,200]"
      description="计算机学院与物产中大国际贸易集团有限公司举办校企合作暨党支部“党建共建”签约仪式"
    />
    <van-divider>2021-11-19</van-divider>
    <van-empty
      @click="out8"
      image="https://jsjdj.hdu.edu.cn/images/9.jpg"
      :image-size="[300,200]"
      description="【学党史 讲廉洁 守初心 】——计算机学院召开师德师风专题学习会"
    />
    <van-divider>2021-11-19</van-divider>
    <van-empty
      @click="out9"
      image="https://jsjdj.hdu.edu.cn/images/10.jpg"
      :image-size="[300,200]"
      description="计算机学院本科18级党支部：开展党风廉政主题党日活动"
    />
    <van-divider>2021-11-12</van-divider>
    <van-empty
      @click="out1"
      image="https://jsjdj.hdu.edu.cn/images/2.jpg"
      :image-size="[300,200]"
      description="计算机学院师生热议十九届六中全会"
    />
    <van-divider>2021-11-12</van-divider>
    <van-empty
      @click="out2"
      image="https://jsjdj.hdu.edu.cn/images/3.jpg"
      :image-size="[300,200]"
      description="计算机学院研究生支部：开展“不忘初心·清廉前行”主题党日活动"
    />
    <van-divider>2021-10-25</van-divider>
    <van-empty
      @click="out"
      image="https://jsjdj.hdu.edu.cn/images/1.jpg"
      :image-size="[300,200]"
      description="【党史学习教育“三为”专题实践】 计算机学院深入走访企业，助力企业发展"
    />
    <van-divider />
  </div>
</template>

<script>
import { watch } from 'vue';
import { useWindowSize } from '@vant/use';

export default {
  setup() {
    const { width, height } = useWindowSize();

    console.log(width.value); // -> 窗口宽度
    console.log(height.value); // -> 窗口高度

    watch([width, height], () => {
      console.log('window resized');
    });
  },
  methods:{
    out(){
      window.location.href = 'http://computer.hdu.edu.cn/2021/1025/c6789a139629/page.htm'
    },
    out1(){
      window.location.href = 'http://computer.hdu.edu.cn/2021/1112/c6789a139637/page.htm'
    },
    out2(){
      window.location.href = 'http://computer.hdu.edu.cn/2021/1112/c6789a139644/page.htm'
    },
    out3(){
      window.location.href = 'http://computer.hdu.edu.cn/2021/1119/c6789a139650/page.htm'
    },
    out4(){
      window.location.href = 'http://computer.hdu.edu.cn/2021/1119/c6789a139656/page.htm'
    },
    out5(){
      window.location.href = 'http://computer.hdu.edu.cn/2021/1119/c6789a139657/page.htm'
    },
    out6(){
      window.location.href = 'http://computer.hdu.edu.cn/2021/1119/c6789a139658/page.htm'
    },
    out7(){
      window.location.href = 'http://computer.hdu.edu.cn/2021/1119/c6789a139659/page.htm'
    },
    out8(){
      window.location.href = 'http://computer.hdu.edu.cn/2021/1119/c6789a139668/page.htm'
    },
    out9(){
      window.location.href = 'http://computer.hdu.edu.cn/2021/1119/c6789a139672/page.htm'
    },
    out10(){
      window.location.href = 'http://computer.hdu.edu.cn/2022/0427/c6789a153783/page.htm'
    },
    out11(){
      window.location.href = 'http://computer.hdu.edu.cn/2022/0613/c6789a154893/page.htm'
    },
    out12(){
      window.location.href = 'http://computer.hdu.edu.cn/2022/0624/c6789a155248/page.htm'
    },
    out13(){
      window.location.href = 'http://computer.hdu.edu.cn/2022/0701/c6789a155458/page.htm'
    },
    out14(){
      window.location.href = 'https://computer.hdu.edu.cn/2022/0707/c6789a155714/page.htm'
    },
    out15(){
      window.location.href = 'https://computer.hdu.edu.cn/2022/0913/c6789a156706/page.htm'
    },
  }
}
</script>

<style>
.van-empty__description{
  padding: 0 !important; 
  color: black !important;
}
.van-empty__image img {
  display: flex;
  justify-content: space-around;
}
.van-empty{
  padding: unset !important; 
  background-color: white;
}
.van-empty__image img{
  height: auto !important;
}
</style>
